import type { MouseEvent } from 'react';
import { Pagination, PaginationItem, PaginationLink, Row } from 'reactstrap';
import '../assets/css/GenericPagination.css'

type GenericPaginationProps = {
  currentPage: number;
  totalPages: number;
  onPageChange: (pageIndex: number) => void;
  pagesToShow?: number;
};

export const GenericPagination = ({ currentPage, totalPages, onPageChange, pagesToShow = 23 }: GenericPaginationProps) => {
  const handlePageClick = (e: MouseEvent<HTMLAnchorElement>, pageIndex: number) => {
    e.preventDefault();
    onPageChange(pageIndex);
  };

  const startPage = Math.floor(currentPage / pagesToShow) * pagesToShow;
  const endPage = Math.min(startPage + pagesToShow, totalPages);

  const renderPaginationItems = () => {
    return Array.from({ length: endPage - startPage }).map((_, i) => {
      const pageIndex = startPage + i;
      return (
        <PaginationItem active={pageIndex === currentPage} key={pageIndex}>
          <PaginationLink onClick={(e: MouseEvent<HTMLAnchorElement>) => handlePageClick(e, pageIndex)} href="#">
            {pageIndex + 1}
          </PaginationLink>
        </PaginationItem>
      );
    });
  };

  const renderNavigationButton = (direction: string, pageOffset: number, iconClass: string, isDisabled: boolean) => (
    <PaginationItem disabled={isDisabled}>
      <PaginationLink onClick={(e: MouseEvent<HTMLAnchorElement>) => handlePageClick(e, currentPage + pageOffset)} href="#">
      <i className={`${iconClass} ${isDisabled ? 'icon-disabled' : ''}`} />
      <span className="sr-only">{direction}</span>
      </PaginationLink>
    </PaginationItem>
  );

  return (
    <Row className="pagination justify-content-center">
      <Pagination className="pagination justify-content-center">
        {renderNavigationButton('Previous', -pagesToShow, 'fa fa-angle-double-left', currentPage - pagesToShow < 0)}
        {renderNavigationButton('Previous', -1, 'fa fa-angle-left', currentPage <= 0)}

        {renderPaginationItems()}

        {renderNavigationButton('Next', 1, 'fa fa-angle-right', currentPage >= totalPages - 1)}
        {renderNavigationButton('Next', pagesToShow, 'fa fa-angle-double-right', currentPage + pagesToShow >= totalPages)}
      </Pagination>
    </Row>
  );
};
